import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    RemoveAttachmentFromLead as RemoveAttachmentFromLeadMutation,
    RemoveAttachmentFromLeadVariables,
    LeadFileRemoveInput,
} from 'nutshell-graphql-types';

import REMOVE_ATTACHMENT_FROM_LEAD from '../mutations/remove-attachment-from-lead.graphql';

export const useRemoveAttachmentFromLead = (): {
    removeAttachmentFromLead: (arg1: LeadFileRemoveInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [removeAttachmentFromLead, {loading, error}] = useMutation<
        RemoveAttachmentFromLeadMutation,
        RemoveAttachmentFromLeadVariables
    >(REMOVE_ATTACHMENT_FROM_LEAD);

    return {
        removeAttachmentFromLead: (input: LeadFileRemoveInput) =>
            removeAttachmentFromLead({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
